export const kebabToCamelCase = (value: string) => {
  if (!value) {
    return '';
  }

  return value.replace(/-./g, (match) => match[1].toUpperCase());
};
